import { useAuth } from './useAuth';
import type { UserPermissions } from '../context/AuthContextType';

export const usePermissions = (): UserPermissions => {
  const { permissions } = useAuth();
  return permissions;
};

export const useHasPermission = (permission: keyof UserPermissions): boolean => {
  const permissions = usePermissions();
  return permissions[permission] === true;
};

export const useCanDeleteProject = () => useHasPermission('can_delete_projects');
export const useCanAccessAdmin = () => useHasPermission('can_access_admin');
export const useCanManageUsers = () => useHasPermission('can_manage_users');
export const useCanCreateProjects = () => useHasPermission('can_create_projects');
export const useCanEditProjects = () => useHasPermission('can_edit_projects');
export const useCanViewProjects = () => useHasPermission('can_view_projects');
export const useCanCreateSubprojects = () => useHasPermission('can_create_subprojects');
export const useCanEditSubprojects = () => useHasPermission('can_edit_subprojects');
export const useCanDeleteSubprojects = () => useHasPermission('can_delete_subprojects');
export const useCanExecuteSearches = () => useHasPermission('can_execute_searches');
export const useCanUseAIChatbot = () => useHasPermission('can_use_ai_chatbot');

export const useCanPrepareRag = () => useHasPermission('can_prepare_rag');
export const useCanViewDocuments = () => useHasPermission('can_view_documents');

export const useCanCreateKnowledgeBases = () => useHasPermission('can_create_knowledge_bases');
export const useCanDeleteKnowledgeBases = () => useHasPermission('can_delete_knowledge_bases');
